import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormik } from 'formik';
import React from 'react';
import DomainForm, { DomainFormState, protocolOptions } from '../../../components/muiLegacy/Forms/DomainForm';
import VoxelButton from '../../../components/voxel/Buttons/VoxelButton';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { DomainGq } from '../../../graphql/projects/models/DomainGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import { DomainTypeGq } from '../../../graphql/projects/models/DomainTypeGq';

export interface EditSingleDomainProps {
  domain: DomainGq;
  onSuccess: (domain: DomainGq) => Promise<any>;
  handleClose: () => void;
  handleDelete: (domain: DomainGq) => void;
}

const EditSingleDomainForm: React.FC<EditSingleDomainProps> = ({
  domain,
  onSuccess,
  handleClose,
  handleDelete,
}) => {
  const updateDomainMutation = projectsApiService.mutations.domains.useUpdateDomain();
  const formikProps = useFormik<DomainFormState>({
    initialValues: {
      domain: domain.hostName,
      protocol: !!domain.protocol.length ? domain.protocol : protocolOptions[0].value,
      type: domain.type,
    },
    onSubmit: (values, actions) =>
      updateDomainMutation({
        projectId: domain.parentProjectId,
        id: domain.id,
        protocol: values.protocol,
        domain: values.domain,
        type: values.type,
      }).then((result) => onSuccess(result)),
  });

  return (
    <div className="p-5 w-[500px]">
      <div className="absolute right-2.5 top-2.5">
        <VoxelIconButton
          icon={<FontAwesomeIcon icon={faTimes} size='lg' />}
          color="white"
          onClick={handleClose}
        />
      </div>
      <VoxelText variant='bread-medium'>Edit domain</VoxelText>
      <div className=" flex flex-col gap-1">
        <div className="w-full py-4 flex flex-col gap-4">
          <DomainForm
            size='sm'
            flexGapClass='gap-2.5'
            protocolValue={formikProps.values.protocol}
            setProtocolValue={(value) => formikProps.setFieldValue('protocol', value)}
            domainValue={formikProps.values.domain}
            setDomainFormState={(valueFunc) => formikProps.setValues(d => { return valueFunc(d) })}
            deleteDomainValue={() => formikProps.setFieldValue('domain', '')}
            placeholder={'www.organization.com/se-sv'}
            disabled={formikProps.isSubmitting}
            showHelperText={formikProps.errors?.domain?.length > 0 && formikProps.submitCount > 0}
            helperText={
              !!formikProps.touched.domain
                ? formikProps.errors.domain
                : 'The exact text will be matched against SERP URLs to check keyword rank performance'
            }
          />
        </div>
        <div className="flex flex-row gap-2 justify-end">
          {domain?.type !== DomainTypeGq.PROJECT && (
            <VoxelButton
              title="Delete"
              color="error"
              size="sm"
              onClick={() => handleDelete(domain)}
            />
          )}
          <VoxelButton
            title="Cancel"
            size="sm"
            color="transparent"
            onClick={handleClose}
            disabled={formikProps.isSubmitting}
          />
          <VoxelButton
            title="Save"
            color="success"
            size="sm"
            onClick={formikProps.submitForm}
            disabled={
              formikProps.isSubmitting
              || !formikProps.dirty
              || !!!formikProps.values.domain
            }
          />
        </div>
      </div>
    </div>
  );
};

export default EditSingleDomainForm;
